import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import CheckoutForm from './CheckoutForm';
import { RETURN_PATHS } from '../../service/checkoutReturn';

import '../../styles/App.css';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

// Stripe Elements checkout for paying a specific invoice (or "pay all").
// The clientSecret comes from POST /me/invoices/:id/pay-intent or
// /me/invoices/pay-all-intent, where the amount was derived server-side.
// Redirects to the same thank-you/receipt page a donation gets
// (CheckoutSuccess.js) rather than back into the dashboard — ?context=
// invoice adjusts its copy and "Back to My Account" button.
export default function InvoiceCheckout({
  clientSecret,
  addressDefaults = null,
  paymentMethodOrder = null,
  returnPath = RETURN_PATHS.invoice,
  intent = 'payment',
}) {
  if (!clientSecret) return null;
  if (!stripePromise) {
    return <p>Payments are not available right now. Please try again later.</p>;
  }

  const options = {
    clientSecret,
    appearance: { theme: 'stripe' },
  };

  return (
    <Elements options={options} stripe={stripePromise}>
      <CheckoutForm
        paymentType="invoice"
        returnPath={returnPath}
        intent={intent}
        addressMode="billing"
        addressDefaults={addressDefaults}
        paymentMethodOrder={paymentMethodOrder}
      />
    </Elements>
  );
}
